<template>
  <div class="sel-tree-box">
    <el-input class="sel-tree-box input-box" ref="inputRef" :value="treeVal" placeholder="请选择" @focus="inputFocusFun"
      readonly @blur="inputBlurFun"></el-input>
    <div :class="[showTreeDialog ? 'show' : 'hide', 'sel-tree-box', 'sel-box']">
      <el-tree @node-click="nodeClick" @node-expand="nodeExpand" @node-collapse="nodeCollapse" :data="treeData"
        :props="treeProps" ref="treeRef" highlight-current default-expand-all :expand-on-click-node="false"></el-tree>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String,Number],
      default: function () {
        return ''
      }
    },
    treeData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      showTreeDialog: false,
      selNodeValue: {},
      treeProps: {
        children: 'children',
        label: 'menuName',
      }
    };
  },
  computed: {
    treeVal: function () {
      let resName = this.selNodeValue ? this.selNodeValue.menuName : ''
      return resName
    }
  },
  watch: {
    value: {
      handler: function (val) {
        // console.log('====parentId=val', val, this.treeData)
        const flattenedArray = this.flattenTree(this.treeData)
        let nodeObj = flattenedArray.find((item) => item.menuId == val)
        // console.log('nodeObj', nodeObj)
        this.selNodeValue = nodeObj || {}
      },
      immediate: true
    }
  },
  methods: {
    inputFocusFun () {
      this.showTreeDialog = true
    },
    inputBlurFun () {
      if (this.inputInterval) {
        clearTimeout(this.inputInterval)
      }
      this.inputInterval = setTimeout(() => {
        if (this.nodeExOrColClick) {
          this.showTreeDialog = true
          return
        }
        this.showTreeDialog = false
      }, 300)
    },
    nodeExpand (event) {
      this.nodeExOrColStop()
    },
    nodeCollapse (event) {
      this.nodeExOrColStop()
    },
    nodeExOrColStop () {
      this.nodeExOrColClick = true
      if (this.nodeExpandInterval) {
        clearTimeout(this.nodeExpandInterval)
      }
      this.nodeExpandInterval = setTimeout(() => {
        this.nodeExOrColClick = false
      }, 350)
    },
    nodeClick (event) {
      // console.log('nodeClick===event===', event)
      this.selNodeValue = event
      this.$emit('input', event.menuId)
      this.showTreeDialog = false
    },
    flattenTree(tree) {
      const result = [];

      function recursiveFlatten (node) {
        const flattenedNode = { ...node }; // 复制节点对象，以防止修改原始数据
        delete flattenedNode.children; // 移除子节点属性，将其转换为一维数组时不需要

        result.push(flattenedNode); // 将当前节点添加到结果数组

        if (node.children && node.children.length > 0) {
          for (const child of node.children) {
            recursiveFlatten(child); // 递归处理子节点
          }
        }
      }

      for (const node of tree) {
        recursiveFlatten(node); // 从每个根节点开始递归
      }

      return result;
    }
  }
}
</script>
<style scoped>
.sel-box {
  width: 100%;
  height: auto;
  max-height: 300px;
  background-color: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  box-sizing: border-box;
  margin-top: 8px;
  transform-origin: center bottom;
  z-index: 2041;
  overflow-y: scroll;
  position: absolute !important;
  left: 0px;
}

.sel-tree-box {
  position: relative;
  width: 100%;
  height: auto;
  display: block;
}

.input-box {
  position: relative;
  z-index: 999999;
}

.show {
  display: block;
}

.hide {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/system/components/TreeSelect.vue